module.exports = __webpack_public_path__ + "static/media/red_card.260facd8.png";